import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DwQueryFilterGroup } from '@devwareapps/devware-cap';
import { CheckrideRequestHomePageQueryEntity } from '../../../../meta-data/app-meta-data.service';
import { DwTaskItem } from '../../../z-devware/tasks/models/dw-task-item.model';
import { buildCheckrideCard, CheckrideCard, isHomeScheduleCheckride } from '../../models/checkride-card.model';
import * as moment_ from 'moment';

const moment = moment_;

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss']
})
export class HomeDashboardComponent implements OnChanges {
  @Input() loading = false;
  @Input() checkridesLoading = false;
  @Input() checkridesError: string;
  @Input() dashboardLabel: string;
  @Input() displayName = '';
  @Input() checkrides: CheckrideRequestHomePageQueryEntity[] = [];
  @Input() paymentViewer: 'examiner' | 'school' | 'applicant' = 'examiner';
  @Input() isOdaSchool = false;
  @Input() tasks: DwTaskItem[] = [];
  @Input() dashboardGroupKey: string;
  @Input() tileDrillDownRoute = '/reports';
  @Input() kpiScopeFilters: DwQueryFilterGroup;
  @Input() expressionContext: any = {};
  @Input() calendarRoute = '/calendar';
  @Input() checkrideRoute = '/bookings';
  @Input() showPlanOfActionActions = true;
  @Input() examinerLabel = '';
  @Input() showFlightSchool = true;

  greeting = this.buildGreeting();
  expandedCheckrideId: number = null;
  selectedScheduleDay: 'today' | 'tomorrow' = 'today';
  todaysCheckrides: CheckrideCard[] = [];
  tomorrowsCheckrides: CheckrideCard[] = [];
  upcomingCheckrides: CheckrideCard[] = [];
  visibleCheckrides: CheckrideCard[] = [];
  readonly skeletonRows = [1, 2, 3];

  get attentionTaskCount(): number {
    return (this.tasks || []).filter(task => task.taskTitle !== 'No current tasks').length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.checkrides && !changes.paymentViewer && !changes.isOdaSchool) {
      return;
    }

    const today = moment().startOf('day');
    const cards = (this.checkrides || [])
      .filter(checkride => isHomeScheduleCheckride(checkride, today))
      .map(checkride => buildCheckrideCard(checkride, this.paymentViewer, this.isOdaSchool))
      .filter(card => card.scheduledMoment && card.scheduledMoment.isValid())
      .sort((left, right) => left.scheduledMoment.valueOf() - right.scheduledMoment.valueOf());
    const tomorrow = today.clone().add(1, 'day');
    const upcomingEnd = today.clone().add(7, 'days').endOf('day');

    this.todaysCheckrides = cards.filter(card => card.scheduledMoment.isSame(today, 'day'));
    this.tomorrowsCheckrides = cards.filter(card => card.scheduledMoment.isSame(tomorrow, 'day'));
    this.upcomingCheckrides = cards.filter(card => card.scheduledMoment.isSameOrAfter(tomorrow)
      && card.scheduledMoment.isSameOrBefore(upcomingEnd));
    this.selectScheduleDay(this.selectedScheduleDay);
  }

  selectScheduleDay(day: 'today' | 'tomorrow'): void {
    this.selectedScheduleDay = day;
    this.visibleCheckrides = day === 'tomorrow' ? this.tomorrowsCheckrides : this.todaysCheckrides;
    this.expandedCheckrideId = null;
  }

  private buildGreeting(): string {
    const hour = moment().hour();
    return hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  }
}
